"use client";

import { cn } from "@/lib/tailwind";
import React from "react";
import AddIcon from "@/assets/icons/add.svg?react";
import MinusIcon from "@/assets/icons/subtract.svg?react";
import { parseNumberFromAttributeValue } from "@/apiUtils/commonUtils";
import { useMediaQuery } from "@/hooks/useMediaQuery";

interface IQuantitySelectorProps {
  className?: string;
  value: number;
  min: number;
  max: number;
  handleAdd: () => void;
  selectedPack?: string;
  handleSub: () => void;
  multipleLabel: string;
  singleLabel: string;
  labelClassName?: string;
}

const QuantitySelector = ({
  value,
  max,
  min,
  handleAdd,
  handleSub,
  multipleLabel,
  singleLabel,
  selectedPack,
  className,
  labelClassName,
}: IQuantitySelectorProps) => {
  const isSmMobile = useMediaQuery("(max-width: 320px)");

  function getLabel(clPackSize: string) {
    const packSize = parseNumberFromAttributeValue(clPackSize);
    if (packSize) {
      return packSize > 1
        ? multipleLabel.replace("{{count}}", packSize?.toString())
        : singleLabel.replace("{{count}}", packSize?.toString());
    }
  }

  return (
    <div className={cn("flex flex-col items-end gap-1", className)}>
      <div className="flex w-24 items-center rounded-[3px] border border-[#C4C4C4] bg-white px-[8px] py-[5px] md:w-28">
        <button
          onClick={handleSub}
          className={cn(
            "flex size-5 items-center rounded-[0.313rem] bg-tertiary-2 p-[0.313rem]",
            value <= min ? "bg-tertiary-6 opacity-50" : "bg-tertiary-2",
          )}
          disabled={value <= min}
        >
          <MinusIcon className="pointer-events-auto h-3 w-3 text-white" />
        </button>
        <span className="h-5 w-5 flex-1 border-0 text-center text-sm focus:outline-0 focus:ring-0">
          {value}
        </span>
        <button
          className={cn(
            "flex size-5 items-center rounded-[0.313rem] p-[0.313rem]",
            value >= max ? "bg-tertiary-6 opacity-50" : "bg-tertiary-2",
          )}
          onClick={handleAdd}
          disabled={value >= max || max === 0}
        >
          <AddIcon className="h-3 w-3 text-white" />
        </button>
      </div>
      {selectedPack && (
        <div className={cn("flex w-full items-center justify-end", labelClassName)}>
          {/*<p className="me-2 text-center text-xs text-tertiary-12 lg:me-4"> */}
          <p
            className={cn(
              "text-center text-xs text-tertiary-12 sm:me-5",
              isSmMobile ? "me-1.5" : "me-4",
            )}
          >
            {getLabel(selectedPack)}
          </p>
        </div>
      )}
    </div>
  );
};

export default QuantitySelector;
